import './Menu.css';

import { IonContent, IonFooter, IonHeader, IonList, IonMenu, IonMenuToggle } from '@ionic/react';
import clsx from 'clsx';
import AuthorizeRequired from 'containers/AuthorizeRequired';
import { AccountAction } from 'interfaces/AccountAction';
import React, { useEffect, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { useLocation } from 'react-router-dom';

import MenuItem from './MenuItem';

interface NavItem {
  url: string;
  icon: string;
  title: string;
  requiredActions?: AccountAction[];
}

interface IMenu {
  menuId?: string;
  contentId: string;
  items: NavItem[];
  renderTopPanel?: () => JSX.Element;
  renderBottomPanel?: () => JSX.Element;
}

const useStyles = createUseStyles({
  content: {
    '--padding-start': '12px',
    '--padding-end': '12px',
    '--padding-top': '14px',
    '--padding-bottom': '12px',
  },
  list: {
    padding: '0 !important',
    '& ion-item': {
      marginBottom: 3,
    },
  },
  header: {
    background: 'var(--ion-toolbar-background, var(--ion-background-color, #fff))',
    paddingTop: 'var(--ion-safe-area-top, 0)',
    borderBottom: '1px solid var(--ion-color-light-shade)',
  },
  footer: {
    background: 'var(--ion-toolbar-background, var(--ion-background-color, #fff))',
    paddingBottom: 'var(--ion-safe-area-bottom, 0)',
  },
});

const Menu: React.FC<IMenu> = ({
  menuId = 'main-menu',
  contentId,
  items = [],
  renderTopPanel,
  renderBottomPanel,
}) => {
  const classes = useStyles();
  const location = useLocation();

  const menuRef = useRef<HTMLIonMenuElement>(null);

  useEffect(() => {
    menuRef.current?.close(true);
  }, [location]);

  return (
    <IonMenu
      ref={menuRef}
      contentId={contentId}
      menuId={menuId}
      type="push"
      side="start"
      className={menuId}
      style={{ '--width': '360px' }}
    >
      <IonHeader className={clsx('ion-no-border', classes.header)}>
        {renderTopPanel && renderTopPanel()}
      </IonHeader>
      <IonContent className={classes.content}>
        <IonList id="nav-list" className={classes.list}>
          <IonMenuToggle autoHide={false} menu={menuId}>
            {items.map((item) => (
              <AuthorizeRequired key={item.url} required={item.requiredActions || []}>
                <MenuItem
                  url={item.url}
                  icon={item.icon}
                  title={item.title}
                  selected={location.pathname.startsWith(item.url)}
                />
              </AuthorizeRequired>
            ))}
          </IonMenuToggle>
        </IonList>
      </IonContent>
      <IonFooter className={clsx('ion-no-border', classes.footer)}>
        {renderBottomPanel && renderBottomPanel()}
      </IonFooter>
    </IonMenu>
  );
};

export default Menu;
